/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */ 

import { CallbackType, FRAuth, FRStep, StepType } from "@forgerock/javascript-sdk";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../redux/hooks";
import QRCodeFactory from 'qrcode-generator';
import { useForm } from "react-hook-form";
import SuccessErrorModal from "../../modals/SuccessErrorModal";
import { FormContainer } from "react-hook-form-mui";
import FormLayout from "../../layout/form";
import { Button } from "@mui/material";
import FormSection from "../../01-atoms/FormSection";
import Row from "../../01-atoms/Row";
import { BaseCallBackInterface } from "../common/basInterface";

export default function RegisterAppQR({ step, setStep,messageType, setMessageType,message,setMessage,tree,isAlertOpen,setIsAlertOpen }: BaseCallBackInterface) {
    const formContext = useForm<{}>({
        defaultValues: {
        }
    });

    //  used for the modal. depreciated
    const [open, setOpen] = useState(false);
    const [qrCodeHtmlqr, setQrCodeHtmlqr] = useState('');
    const [qrCodeMobileLink, SetQrCodeMobileLink] = useState('');
    
  const [isDisabled,setDisabled] = useState(false);

    useEffect(()=>{
        if(!!step && step.getStage() === "RegisterApp")
            createCode({text:step.getCallbackOfType(CallbackType.HiddenValueCallback).getOutputByName('value','')})
    },[])


 const createCode = (options: { text?: any; code?: any; version?: any; }) => {
    const { code = 'M', version = 0, text } = options;
    const qr =  QRCodeFactory(version, code);
    qr.addData(text);
    qr.make();
    setQrCodeHtmlqr(qr.createImgTag(3,8));
    SetQrCodeMobileLink(text);
  }

   //  ---------------------METHODS-----------------------------------

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSuccess = async (data: any) => {
        setDisabled(true)
        handleClose();
        let nextStep = await FRAuth.next(step as FRStep,{tree});
        setStep(nextStep);
        setTimeout(()=>{
            setDisabled(false);
          },2)
    };

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setMessageType(false)
        setOpen(false);
    };

     //  -----------------END METHODS-----------------------------------

     return (
        <>
            <FormContainer
                defaultValues={{}}
                formContext={formContext}
                onSuccess={handleSuccess}>
                <SuccessErrorModal
                    open={open}
                    type={messageType}
                    handleClose={handleClose}
                    message={message}
                />
                <FormLayout
                    header={step.getHeader()}
                    subHeader={step.getDescription()}
                    disabled={isDisabled}
                    button={(<button  id="submit_button" className={`accent-1 submit`} disabled={isDisabled} type="submit" >Continue</button>)}>                    <FormSection>
                        <Row>
                            <div dangerouslySetInnerHTML={{__html: qrCodeHtmlqr}} /> 
                            </Row>
                            <Row>
                                <a href={qrCodeMobileLink}>On Mobile Device?</a>
                            </Row>
                    </FormSection>

                </FormLayout>
            </FormContainer>
        </>
    );
}